import { css } from '@emotion/react'
import { medium, small } from '../../GlobalStyles'

export const UnStickyTriggerStyle = css`

  position: absolute;
  width: 1px;
  height: 1px;
  display: block;
  top:1px;
  right: 1px;
  background-color: transparent;

`

export const NavBarStyle = css`

    display: flex;
    align-items: center;
    box-shadow: -1px 0px 4px 1px hsl(58deg 4% 50% / 22%);
    z-index: 1;
    padding: 23px 15px 15px 15px;
    box-sizing: border-box;
    z-index: 2;
    position: fixed;
    width: 100%;
    top:0;
    background-color: rgba(255,255,255,0.9);
    backdrop-filter: blur(2px);
    transition: all 0.4s ease;
    transform: translateZ(0);
    transform-origin: top left;

    .stickyMode &{
      transform: scaley(50%);
    }

    /* ${medium}{
      padding-right: 17%;
    } */

`

export const HeaderWrapperStyle = css`

    display: flex;
    align-items: center;
    z-index: 1;
    max-width: 100%;
    overflow: hidden;
    a{
      display: flex;
      align-items: center;
      text-decoration: none;
      text-decoration: none !important;
    }
`

export const LnuTextStyle = css`

  display: flex;
  flex-direction: column;
  img{
    max-width: 230px;
    margin-bottom: 4px;
    margin-top: 2px;
    position: relative;
    transition: all 0.4s ease;
    transform: translateZ(0);
    .stickyMode & {
      transform: translateY(-100px);
    }
  }
  div{
    transition: all 0.4s ease;
    transform: translateZ(0);
    .stickyMode & {
      transform: translateY(-15px) translateX(-10px) scaley(200%);
      ${small}{
        transform: translateY(-15px) scaley(200%);
      }
    }
  }
`

export const CourseNameStyle = css`

  color: #000;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 300;


  ${medium}{  
    
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    .stickyMode &{
      max-width: 93%;
    }
  }
  ${small}{
    font-size: 14px;
    line-height: 2;
    .stickyMode &{
      max-width: 100%;
    }
  }

`

export const TreeLogoStyle = css`

  background-color: #FFE31A;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-right: 16px;
  box-shadow: 0px 0px 0px 1px rgba(0,0,0,0.07);
  transition: all 0.4s ease;
  transform: translateZ(0);
  img{
    max-height: calc(100% - 12px);
    position: relative;
    left: 1px;
  }

  .stickyMode &{
    transform:  scaley(120%) scaleX(65%);
  }

    ${small}{
      display: none;
    }

`


export const ToolsLinkStyle = css`

    position: absolute;
    right: 20px;
    top: 40px;
    display: flex;
    flex-direction: row;
    list-style: none;
    box-sizing: border-box;
    transition: all 0.4s ease;
    transform: translateZ(0);

    ${medium}{
      display: none;
    }

    li{
      padding: 0 10px;
      border-left: 1px solid black;
      :first-of-type{
        border-left: none;
      }
      a{
        font-weight: normal;
        text-decoration: none;
        font-size: 14px;
      }
    }

    .stickyMode &{
      transform: scaley(200%);
    }


`

export const HamburgerMenuButtonStyle = css`

    display: none;
    width: 35px;
    height: 28px;
    background: transparent;
    position: absolute;
    right: 30px;
    top: 30px;
    transition: all 0.4s ease;
    border: none;
    border-bottom: 3px solid #000;
    border-top: 3px solid #000;
    border-radius: 1px;
    padding: 10px;
    z-index: 3;
    
    ${medium}{
      display: block;
      top: 20px;
      .stickyMode &{
        transform: scaley(200%);
        top: 30px;
      }
    }
    ${small}{
      right: 15px;
    }
    

    &:after{
      content: "";
      width: 35px;
      height: 5px;
      position: absolute;
      display: block;
      left: 0px;
      top: 5px;
      border-top: 3px solid #000;
      border-bottom: 3px solid #000;
    }

    .stickyMode &{
      transform: scaley(200%);
      right: 2.5%;
    }

    &:focus-visible{
      border-color: #FAC158;
      border-radius: 4px;
      border-width: 8px;
      padding: 0px;
      height: 29px;
      outline: none;
      &:after{
        width: 35px;
        height: 2px;
        top: 2px;
        border-top-color: #64CA19;
        border-bottom-color: #624709;
        border-bottom-width: 4px;
      }
    }

`